
import React, { useState, useEffect } from 'react';
import Button from '../../partials/Button'
import Popup from '../../partials/Popup/Popup'
import Scroll from '../../partials/Scroll/Scroll';

const SubTeamQuiz = props => {
    const data = props.data;
    //int representing current selected option index
    const [selected, setSelected] = useState(-1);
    const [participantSelect, setParticipantSelect] = useState(-1)
    const [participantDialogue, setParticipantDialogue] = useState("");
    const [showParticipantDialogue, setShowParticipantDialogue] = useState(false)
    const [alert, setAlert] = useState([])
    const [optionSelected, setOptionSelected] = useState(false)
    const [showFeedback, setShowFeedback] = useState(false)
    const [feedbackData, setFeedbackData] = useState({ scrim: true, header: "", body: "", button: "Close", config: data?.config })

    const handleOptionClick = (optionIndex) => {
        setSelected(optionIndex)
        if (props.setCurrentChoice) props.setCurrentChoice(optionIndex)
        setParticipantSelect(-1)
    }

    useEffect(() => {
        console.log('hellor' + participantDialogue)
    }
        , [participantDialogue])

    let handleParticipantClick = (participant, i) => {
        console.log(participant)
        setParticipantSelect(i)
        setShowParticipantDialogue(participant.initialState === 'alert')
        setParticipantDialogue(participant.dialogue)
        let newArr = alert
        newArr[i] = false
        setAlert(newArr)
    }

    const participants = () => {
        if (selected === -1) {
            return data.participantsInital.map((item, i) => {
                return (
                    <>
                        <div className={`QuizParticipant ${item.initialState === "deactive" && "deactivated"}`}>
                            <div onClick={() => handleParticipantClick(item, i)} className={`person`}>
                                <img src={item.image} alt={item.dialogue} />
                                {optionSelected &&
                                    <div className={`${item.initialState === "alert" && 'alert'}`} />
                                }
                            </div>
                        </div>
                    </>
                )
            })
        } else {
            return data.options[selected].participants.map((item, i) => {
                return (
                    <>
                        <div className={`QuizParticipant ${item.initialState === "deactive" && "deactivated"}`}>
                            <div onClick={() => handleParticipantClick(item, i)} className={`person`}>
                                <img src={item.image} alt={item.dialogue} />
                                <div className={`${item.initialState === "alert" && alert[i] && 'alert'}`} >
                                    {item.initialState === "alert" &&
                                        <img src={props?.config?.dialogueIcon || 'media/img/dialogue_icon.png'} alt={props?.config?.dialogueIconAlt} />
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                )
            })
        }
    }

    let handleDoneClick = () => {
        let newFeedback = feedbackData;
                newFeedback.header = ""
                newFeedback.body = data.options[selected].feedback
                newFeedback.button = "Close"
                setFeedbackData(newFeedback)
                setShowFeedback(true)
    }

    let handleCloseClick = () => {
        setOptionSelected(false)
        setShowFeedback(false)
        console.log('complete')
        if (selected != -1) {
            setShowParticipantDialogue(false)
            setSelected(-1)
            if (props.onComplete) props.onComplete(selected)
        }
    }

    useEffect(() => {
        if (selected !== -1) {
            let newArr = [...data.options[selected].participants.map(x => x.initialState === "alert")]
            setAlert(newArr)
        }
    }, [selected])

    return (
        <div className="SubTeamQuiz">
            {data.scenario &&
                <Scroll className="textContainer">
                    <div className="textBlock" dangerouslySetInnerHTML={{ __html: data.header + data.scenario + data.question + data.instructions }} />
                </Scroll>
            }

            <div className="questionContainer">
                <div className="questionBlock">
                    <div className={`options`}>
                        {
                            data.options.map((option, optionIndex) => {
                                return <div className={`optionBtn ${option.text.toLowerCase() + '-but'} ${selected === optionIndex ? 'selected' : "not-selected"}`} onClick={() => handleOptionClick(optionIndex)}>
                                    <div className={`${option.text.toLowerCase() + '-icon'}`}></div>{option.text}
                                </div>
                            })
                        }
                    </div>
                    {!optionSelected &&
                        <div className="completeBtn">
                            <Button text="Submit" className={`doneBtn ${selected === -1 && 'disabled'}`} onClick={handleDoneClick} />
                        </div>
                    }
                </div>
                <div className="participantsBlock">
                    <div className="participantsList">
                        {participants()}
                    </div>
                    {showParticipantDialogue &&
                    <div className="participantDialogue">
                        {participantDialogue}
                    </div>  }
                </div>
            </div>
           
            
            {showFeedback &&
                <Popup data={feedbackData} onClose={() => handleCloseClick()} />

            }
        </div>
    )
}

export default SubTeamQuiz;